import { ROUTER_PARAM_LANGUAGE, ROUTER_PARAM_PACKAGE_GROUP } from "@/router/router-params";
import { useSettingsStore } from "@/stores";

/**
 * Syncs package and language state based on url params.
 *
 * If user tries to access a package or language without having access to it, they
 * are redirected so url params always reflect the current valid state.
 *
 * @type {import("vue-router").NavigationGuard}
 */
export default (to, from, next) => {
  const settingsStore = useSettingsStore();

  /** @type {Record<string, string>} */
  const redirectParams = {};

  const packageGroup = to.params?.[ROUTER_PARAM_PACKAGE_GROUP];
  if (packageGroup !== settingsStore.preferredPackageGroup?.id) {
    try {
      settingsStore.updateActivePackageGroup(packageGroup);
    } catch (e) {
      redirectParams[ROUTER_PARAM_PACKAGE_GROUP] = settingsStore.preferredPackageGroup?.id;
    }
  }

  const language = to.params?.[ROUTER_PARAM_LANGUAGE];
  if (language !== settingsStore.activeLanguageGroup) {
    try {
      settingsStore.setActiveLanguageGroup(language);
    } catch (e) {
      redirectParams[ROUTER_PARAM_LANGUAGE] = settingsStore.activeLanguageGroup;
    }
  }

  // One or more params needs updating for url to reflect state
  if (Object.keys(redirectParams).length > 0) {
    return next({
      ...to,
      params: {
        ...to.params,
        ...redirectParams
      }
    });
  }

  return next();
};
